import Vue from 'vue'
import VueI18n from 'vue-i18n'
import id from './id.json'
import en from './en.json'
import cn from './cn.json'

Vue.use(VueI18n)

const messages = {
  id,
  en,
  cn
}

// Ambil bahasa dari localStorage, jika tidak ada fallback ke 'id'
const savedLanguage = localStorage.getItem('user-lang') || 'en'

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages
})

export default i18n
